<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img
        class="page_topreturn"
        src="/static/fanhui.png"
        @click="pageReturn()"
      />
      <div class="page_toptext">卡券列表</div>
      <img
        class="page_topreturnindex"
        src="/static/fanhuishouye.png"
        @click="pageToIndex()"
      />
    </div>
    <!-- 返回 结束 -->
    <div class="page">
      <!-- nav:导航栏 start -->
      <div class="page_tab coupon_tab">
        <div
          class="page_tablist"
          v-for="(item, index) in nav"
          @click="changeNavIndex(index)"
        >
          <div :class="navIndex == index ? 'page_tabname' : 'page_tabname1'">
            {{ item }}
          </div>
        </div>
      </div>
      <!-- nav:导航栏 end -->
      <div v-if="list.length > 0">
        <div v-for="(item, index) in list" :key="index">
          <div
            class="section coupon"
            v-if="item.type == 5"
            @click="navIndex == 2 ? '' : toCouponDetailPro(index)"
          >
            <div class="coupon_top">
              <div class="couton_top_l">
                <img class="thumb" src="/static/ticket.png" />
                <div class="desc greyColor">
                  <div class="title">{{ item.coupon.name }}券</div>
                  <div class="code">编号：{{ item.card_no }}</div>
                </div>
              </div>
              <img
                v-if="item.type == 1"
                class="codeicon"
                src="/static/code.png"
              />
            </div>
            <div class="overdate" v-if="navIndex == 0 && item.overdue_at">
              过期时间：{{ item.overdue_at }}
            </div>
            <div class="overdate" v-if="navIndex == 1 && item.used_at">
              使用时间：{{ item.used_at }}
            </div>
            <div class="overdate" v-if="navIndex == 2 && item.used_at">
              使用时间：{{ item.used_at }}
            </div>
          </div>
          <div
            v-else
            class="section coupon"
            @click="navIndex == 2 ? '' : toDetail(index)"
          >
            <div class="coupon_top">
              <div class="couton_top_l">
                <img
                  class="thumb"
                  :src="
                    item.product.thumb
                      ? item.product.thumb
                      : '/static/ticket.png'
                  "
                />
                <div class="desc greyColor">
                  <div class="title" v-if="item.product_id == 9">
                    {{ item.product.name }}{{ item.productItem.name }}券
                  </div>
                  <div class="title" v-else>
                    {{
                      item.product.type == 5
                        ? item.related.name
                        : item.name
                        ? item.name
                        : item.product.name
                    }}
                  </div>
                  <div class="code" v-if="item.product_id == 9">
                    大家来加油{{ item.productItem.name }}卡券
                  </div>
                  <div class="code" v-else>编号：{{ item.card_no }}</div>
                  <div class="code1" v-if="item.store">
                    此卡券仅供"<span style="color: #029DFF;">{{
                      item.store.name
                    }}</span
                    >"店铺使用
                  </div>
                </div>
              </div>
              <img
                v-if="item.type == 1"
                class="codeicon"
                src="/static/code.png"
              />
            </div>
            <div class="overdate" v-if="navIndex == 0 && item.overdue_at">
              过期时间：{{ item.overdue_at }}
            </div>
            <div class="overdate" v-if="navIndex == 1 && item.used_at">
              使用时间：{{ item.used_at }}
            </div>
            <div class="overdate" v-if="navIndex == 2 && item.used_at">
              使用时间：{{ item.used_at }}
            </div>
          </div>
        </div>
        <div @click="getMore()" class="coupon_label more" v-if="datalengthX">
          查看更多
        </div>
        <div class="nulldiv"></div>
      </div>
      <!-- 暂无信息  开始 -->
      <div class="page_none" v-else :hidden="navIndex != 0">
        <img
          src="/static/newprojecticon/zanwujilu.png"
          class="page_none_icon"
        />
      </div>
      <!-- 暂无信息  结束 -->
      <!-- coupon list end -->

      <!-- button start -->
      <!--<img class="commonBg" src="../../images/coupons/plus.png" @click="tap" id="toAccount"/>-->
      <!-- button end -->
    </div>
  </div>
</template>
<script>
import httper from "../../api/http";
import { Dialog } from "vant";
export default {
  data() {
    return {
      nav: ["未使用", "待处理", "已使用"], // 导航栏列表
      navIndex: 0, // 导航栏列表指针,默认为0
      pageSize: 5, // 列表每页页数,默认为20
      showItem: {}, //获取用户信息
      mobile: "", //用户手机号

      list: [], //列表
      datalengthX: false, //判断是否要继续请求列表,默认值false
      pages: 1 //判断是否要继续请求页数,默认值1
    };
  },
  created() {
    this.request("getUserInfo");
    this.changeNavIndex(this.navIndex);
  },
  mounted() {},
  methods: {
    pageReturn() {
      this.$router.go(-1);
    },
    pageToIndex() {
      this.$router.push({
        path: "/"
      });
    },
    // 改变导航栏指针
    changeNavIndex(index, page = 1, reset_list = true) {
      let that = this;
      that.navIndex = index;
      that.pages = page;
      if (reset_list) {
        that.list = [];
      }
      let requestData = {
        status: that.navIndex,
        page: page,
        page_size: that.pageSize
      };
      this.request("getCouponList", requestData);
    },
    // 跳转到充值页面
    toAccount() {
      if (!this.showItem.mobile) {
        Dialog.confirm({
          title: "提示",
          message: "请先绑定手机"
        })
          .then(() => {
            that.$router.push({
              path: "/changePhoneNum"
            });
          })
          .catch(() => {
            return false;
          });
        // this.$swal({
        //     title: '提示',
        //     text: "请先绑定手机号？",
        //     buttons: ['取消', '确认'],
        // }).then((confirm) => {
        //     if (confirm) {
        //         //跳去手机绑定页
        //         this.$router.push({
        //             path: '/changePhoneNum'
        //         })
        //     } else {
        //         return false;
        //     }
        // })
        // this.$messagebox.alert('', {
        //   title: "提示",
        //   message: "请先绑定手机",
        // }).then(action => {
        //   console.log(action)
        //   if (action == 'confirm') {
        //     that.$router.push({
        //       path: "/changePhoneNum"
        //     })
        //   } else {
        //     return false;
        //   }
        // })
        return;
      }
      this.$router.push({
        path: "/account"
      });
    },
    //跳转卡券详情不同界面
    toDetail(e) {
      // window.location.href = "https://mp.weixin.qq.com/s/INcCBbOO399yaXm5B5Ak-A"
      let that = this;
      console.log("that.navIndex", that.navIndex);
      console.log("that.list[e].type", that.list[e].type);
      if (that.navIndex == 1) {
        // 跳转到卡券详情页（预约）
        this.bookDetail(that.list[e].id);
      } else if (that.list[e].type == 2 && that.list[e].product_id != 9) {
        this.toDescDetail(e);
      } else if (that.list[e].type == 1) {
        this.toDesc(that.list[e].id);
      } else if (that.list[e].product.type == 5) {
        this.$router.push({
          path: "/yearInspectionType"
        });
      } else if (that.list[e].product_id == 9) {
        let productItemId = that.list[e].product_item_id;
        let price = that.list[e].productItem.price;
        let couponId = that.list[e].id;
        this.$router.push({
          path: "/oilCard",
          query: {
            productItemId: productItemId,
            price: price,
            couponId: couponId
          }
        });
      } else if (that.list[e].type == 3) {
        this.toServiceList(
          that.list[e].product_id,
          that.list[e].id,
          that.list[e].store_id
        );
      } else if (that.list[e].type == 4) {
        let product_id = that.list[e].product_id;
        let card_no = that.list[e].id;
        this.$router.push({
          path: "/projectDetail",
          query: {
            id: product_id,
            card_no: card_no
          }
        });
      }
    },
    toCouponDetailPro(e) {
      let that = this;
      let id = that.list[e].id;
      this.$router.push({
        path: "/couponDetailPro",
        query: {
          id: id
        }
      });
    },
    toDescDetail(e) {
      var CardDetail = this.list[e];
      console.log("CardDetail", CardDetail);
      this.$router.push({
        path: "/couponsDesc",
        query: {
          CardDetail: CardDetail
        }
      });
    },
    //跳转到卡券详情页
    toDesc(id) {
      this.$router.push({
        path: "/couponsDesc",
        query: {
          id: id
        }
      });
    },
    // 跳转到卡券详情页（预约）
    bookDetail(id) {
      this.$router.push({
        path: "/detailBook",
        query: {
          id: id
        }
      });
    },
    // 跳转到服务商家页面(带预约编号的参数
    toServiceList(product_id, id, store_id) {
      if (store_id) {
        this.$router.push({
          path: "/serviceDesc",
          query: {
            booking_id: product_id,
            product_id: product_id,
            package_id: id,
            store_id: store_id
          }
        });
      } else {
        this.$router.push({
          path: "/serviceList",
          query: {
            booking_id: product_id,
            product_id: product_id,
            package_id: id
          }
        });
      }
    },
    // // 点击触发
    // tap(e) {
    //   let currentTarget = e.currentTarget
    //   let dataset = currentTarget.dataset
    //   let that = this
    //   let data = {}
    //   let requestData = {}
    //   switch (currentTarget.id) {
    //       // 跳转到服务商家页面(带预约编号的参数
    //     case 'toServiceList':
    //       wx.navigateTo({
    //         url: '../service/serviceList?booking_id=' + dataset.product_id + '&product_id=' + dataset.product_id + '&package_id=' + dataset.id
    //       })
    //       break
    //   }
    // },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        // 获取卡券列表
        case "getCouponList":
          httper.post(
            "/coupon/user-package",
            requestData,
            res => {
              let datalengthX = res.data.length - that.pageSize === 0;
              that.datalengthX = datalengthX;

              if (res.data.length > 0) {
                let list = that.list;
                for (let i = 0; i < res.data.length; i++) {
                  list.push(res.data[i]);
                }
                that.list = list;
              }
            },
            true
          );
          break;
        // 获取用户信息
        case "getUserInfo":
          httper.get(
            "wechat/user/info",
            requestData,
            res => {
              if (res.code == 0) {
                that.showItem = res.data;
                that.mobile = res.data.mobile;
              }
            },
            true
          );
          break;
      }
    },

    //查看更多
    getMore() {
      let that = this;
      if (!that.datalengthX) {
        this.$toast({
          message: "没有更多了"
        });
        return;
      }
      let page = that.pages + 1;
      that.changeNavIndex(that.navIndex, page, false);
    }
  }
};
</script>
<style scoped>
.nulldiv {
  height: 100px;
  width: 100%;
}

/* coupon */

.coupon {
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 90px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  border-radius: 8px;
}

.coupon_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
  border-bottom: 1px dashed rgba(98, 98, 98, 1);
}

.couton_top_l {
  display: flex;
  align-items: center;
}

.coupon:first-child {
  margin-top: 10px;
}

.thumb {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}

.title {
  margin: 5px 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(54, 54, 54, 1);
}

.code {
  font-size: 9px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.code1 {
  font-size: 9px;
  margin: 5px 0;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.overdate {
  margin-top: 10px;
  font-size: 9px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.desc {
  display: flex;
  flex-direction: column;
  font-size: 11px;
}

.codeicon {
  width: 58px;
  height: 58px;
}

.couponList_label {
  margin: 20px 15px 0;
  display: block;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.coupon_label {
  margin: 20px 15px 0;
  display: block;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.more {
  padding: 10px 0;
  text-align: center;
  font-size: 15px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 3px 3px #e3e3e3;
  color: orange;
  border-radius: 10px;
}

/* button */
.commonBg {
  width: 30px;
  height: 30px;
  padding: 10px;
  border-radius: 50%;
  position: absolute;
  bottom: 15px;
  left: 15px;
  box-shadow: 0 10px 10px #e3e3e3;
}

.coupon_tab {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/kaquan/couponsList.vue